import api from 'config/axios';
import { Buffer } from 'buffer';
import { CTeUpload } from 'common/upload.interface';
import AppService from 'common/app-service';

export default class UploadService extends AppService {
  constructor() {
    super('/dfes/upload', api);
  }

  generateBatchId = async () => {
    const response = await this.api.post(`${this.servicePath}/batch-id`);
    return response.data;
  };

  generateCTeUploadUrls = async (totalUrls: number): Promise<CTeUpload[]> => {
    const response: any = await this.api.post(`${this.servicePath}`, {
      file_ext: '.xml',
      qtd: totalUrls,
    });

    return response.data;
  };

  uploadCteToS3 = async (uploadUrl: string, file: File) => {
    return fetch(uploadUrl, {
      method: 'PUT',
      body: Buffer.from(await file.arrayBuffer()),
    }).then((res) => (res.status > 300 ? Promise.reject() : res));
  };

  deleteFile = async (batchId: string, filename: string) => {
    const response = await this.api.delete(`${this.servicePath}/${batchId}/${filename}`);

    return response.data;
  };
}
